import { render, staticRenderFns } from "./OrganizationActionFlow.vue?vue&type=template&id=51174f56"
import script from "./OrganizationActionFlow.vue?vue&type=script&lang=js"
export * from "./OrganizationActionFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports